// import { useState } from "react";
// import icons from "../../icons.config";

// const coupons = [
//   {
//     image: icons.couponsIcon,
//     background: "bg-[var(--primary1)]",
//     discount: "Up to 40% Off",
//     description: "Get discounts on select items",
//     code: "SAVE40",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-[var(--primary1)]",
//     discount: "Flat 30% Off",
//     description: "Limited time offer",
//     code: "FLAT30",
//   },
//   {
//     image:icons.couponsIcon,
//     background: "bg-[var(--primary1)]",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-[var(--hcolor)]",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-[var(--primary1)]",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-[var(--primary1)]",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   // Add more coupons here
// ];

// export default function CouponsSection() {
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const visibleCoupons = () => {
//     if (window.innerWidth >= 1024) return 3.5;
//     if (window.innerWidth >= 768) return 2.5;
//     return 1.5;
//   };

//   const nextSlide = () => {
//     if (currentIndex < coupons.length - visibleCoupons()) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const prevSlide = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(currentIndex - 1);
//     }
//   };

//   return (
//     <div className="w-full flex flex-col items-center p-6 overflow-hidden">
//       {coupons.length === 0 ? (
//         <div className="text-center">
//           <img
//             src="/no-coupons.png"
//             alt="No Coupons"
//             className="w-48 mx-auto mb-4"
//           />
//           <p className="text-lg font-semibold">You don’t have any coupons.</p>
//         </div>
//       ) : (
//         <div className="relative w-full overflow-hidden">
//           <div className="flex transition-transform duration-1000"
//                >
//             {coupons.map((coupon, index) => (
//               <div
//                 key={index}
//                 className="  px-2">
//                 <div className="border rounded-lg w-48 shadow-lg">
//                   <img src={coupon.image} alt="Coupon" className=" h-32  items-center flex" />
//                   <div className={`p-4 text-center ${coupon.background}`}
//                   > 
//                     <h3 className="text-xl font-bold">{coupon.discount}</h3>
//                     <p className="text-sm text-gray-600">{coupon.description}</p>
//                     <div className="flex justify-center items-center mt-2">
//                       <span className="bg-white px-3 py-1 rounded-lg shadow text-lg font-semibold">{coupon.code}</span>
//                       <img src={icons.copyCode} onClick={() => navigator.clipboard.writeText(coupon.code)} className="w-5 h-5 ml-2"/>
                       
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//           {/* <Button variant="ghost" size="icon" onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2">
//             <ChevronLeft className="w-6 h-6" />
//           </Button> */}
//            <img src={icons.arrowLeft} alt="left arrow"
//           className="absolute  left-0 top-1/2 -translate-y-1/2 text-primary1 text-lg font-semibold w-8 h-8 rounded-[50%] z-20 bg-secondary "
//           onClick={prevSlide}
//         />
//           {/* <Button variant="ghost" size="icon" onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2">
//             <ChevronRight className="w-6 h-6" />
//           </Button> */}
//  <img src={icons.arrowRight} alt="right arrow"
//           className="absolute  right-0 top-1/2 -translate-y-1/2 text-primary1 rounded-[50%] bg-secondary   w-8 h-8 z-10"
//           onClick={nextSlide}
//         />
//         </div>
//       )}
//     </div>
//   );
// }


// import { useState, useEffect } from "react";
// import icons from "../../icons.config";

// const coupons = [
//   {
//     image: icons.couponsIcon,
//     background: "bg-hcolor",

//     // background: "bg-[var(--primary1)]",
//     discount: "Up to 40% Off",
//     description: "Get discounts on select items",
//     code: "SAVE40",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-secondary",

//     // background: "bg-[var(--primary1)]",
//     discount: "Flat 30% Off",
//     description: "Limited time offer",
//     code: "FLAT30",
//   },
//   {
//     image: icons.couponsIcon,
//     background: "bg-primary1",

//     // background: "bg-[var(--primary1)]",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   {
//     image: icons.couponsIcon,
//     // background: "bg-[var(--primary1)]",
//     background: "bg-primary2",

//     discount: "Up to 40% Off",
//     description: "Get discounts on select items",
//     code: "SAVE40",
//   },
//   {
//     image: icons.couponsIcon,
//      background: "bg-primary1",
//     // background: "bg-[var(--primary1)]",
//     discount: "Flat 30% Off",
//     description: "Limited time offer",
//     code: "FLAT30",
//   },
//   {
//     image: icons.couponsIcon,
//     background:"bg-hcolor",
//     discount: "Buy 1 Get 1 Free",
//     description: "On selected products",
//     code: "B1G1",
//   },
//   // Add more coupons here
// ];

// export default function CouponsSection() {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [visibleCoupons, setVisibleCoupons] = useState(1);

//   useEffect(() => {
//     const updateVisibleCoupons = () => {
//       if (window.innerWidth >= 1024) setVisibleCoupons(3);
//       else if (window.innerWidth >= 768) setVisibleCoupons(2);
//       else setVisibleCoupons(1);
//     };

//     updateVisibleCoupons();
//     window.addEventListener("resize", updateVisibleCoupons);
//     return () => window.removeEventListener("resize", updateVisibleCoupons);
//   }, []);

//   const nextSlide = () => {
//     if (currentIndex < coupons.length - visibleCoupons) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const prevSlide = () => {
//     if (currentIndex > 0) {
//       setCurrentIndex(currentIndex - 1);
//     }
//   };

//   return (
//     <div className="w-full flex flex-col lg:pl-12 ">
//       {coupons.length === 0 ? (
//         <>
//          <div className="text-center flex item-center">
//           <img src={icons.couponsIcon} alt="No Coupons" className="w-48 mx-auto mb-4" />

//         </div>
//                   <p className="text-lg font-semibold flex items-center">You don’t have any coupons.</p></>
       
//       ) : (
//         <div className="relative w-full overflow-hidden z-20">
//           <div
//             className="flex transition-transform duration-500"
//             style={{ transform: `translateX(-${currentIndex * (100 / visibleCoupons)}%)` }}
//           >
//             {coupons.map((coupon, index) => (
//               <div key={index} className="w-full md:w-1/2 lg:w-[40%] xl:w-[35%] 2xl:w-[26%]  px-2 flex-shrink-0 mt-5 z-30">
//                 <div className="border rounded-lg shadow-lg overflow-hidden">
//                   <div className={`h-40 flex justify-center items-center relative`}>
//                     <div className={`absolute inset-0 ${coupon.background || "bg-primary1"} opacity-20`}></div>

//                     <img src={coupon.image} alt="Coupon" className="h-32 z-10" />
//                   </div>
//                   <div className={`p-3 text-center`}>

//                     <h3 className="text-xl font-bold">{coupon.discount}</h3>
//                     <p className="text-sm text-gray-600">{coupon.description}</p>
//                     <div className="flex justify-center items-center mt-2">
//                       <span className=" text-lg font-semibold">Code-
//                        <span> {coupon.code}</span>
//                       </span>
//                       <img
//                         src={icons.copyCode}
//                         onClick={() => navigator.clipboard.writeText(coupon.code)}
//                         className="w-5 h-5 ml-2 cursor-pointer items-end"
//                         alt="Copy"
//                       />
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}

//           </div>
        
//          <div className="flex gap-8 mt-10 relative -right-[70%]">
//         <button onClick={prevSlide} className="p-2 bg-secondary rounded-full shadow-md">
//           <img src={icons.arrowLeft} alt="Previous" className="w-7 h-7" />
//         </button>
//         <button onClick={nextSlide} className="p-2 bg-secondary rounded-full shadow-md">
//           <img src={icons.arrowRight} alt="Next" className="w-7 h-7" />
//         </button>
//       </div>
//         </div>
        
//       )}
     
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { fetchCoupons } from "../../Providers/couponsProvider";
import icons from "../../icons.config";
import { useNavigate } from "react-router-dom";

export default function CouponsSection() {
  const [coupons, setCoupons] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCoupons, setVisibleCoupons] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const navigate= useNavigate();

  const backgroundColors = ["bg-hcolor", "bg-hcolor", "bg-primary1", "bg-secondary"];

  useEffect(() => {
    const updateVisibleCoupons = () => {
      if (window.innerWidth >= 1024) setVisibleCoupons(3);
      else if (window.innerWidth >= 768) setVisibleCoupons(2);
      else setVisibleCoupons(1);
    };

    updateVisibleCoupons();
    window.addEventListener("resize", updateVisibleCoupons);
    return () => window.removeEventListener("resize", updateVisibleCoupons);
  }, []);

  useEffect(() => {
    const getCoupons = async () => {
      setLoading(true);
      const { data } = await fetchCoupons();
      if (data) {
        const formattedCoupons = data.map((coupon, index) => ({
          image: icons.couponsIcon,
          background: backgroundColors[index % backgroundColors.length],
          discount: coupon.discount_type === "percentage" ? `${coupon.discount}% Off` : `₹${coupon.discount} Off`,
          description: coupon.description,
          code: coupon.code,
        }));
        setCoupons(formattedCoupons);
      }
      setLoading(false);
    };
    getCoupons();
  }, []);

  const nextSlide = () => {
    if (currentIndex < coupons.length - visibleCoupons) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const prevSlide = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Function to handle modal open & disable background scrolling
  // Function to handle modal open & disable background scrolling
const openModal = (coupon) => {
  setSelectedCoupon({
    ...coupon,
    bgColor: getComputedStyle(document.documentElement)
      .getPropertyValue(`--${coupon.background.replace("bg-", "")}`)
      .trim(), // Get CSS variable color
  });
  document.body.style.overflow = "hidden"; // Disable scroll
};


  // Function to close modal & enable background scrolling
  const closeModal = () => {
    setSelectedCoupon(null);
    document.body.style.overflow = "auto"; // Enable scroll
  };

  return (
    <div className="w-full flex flex-col lg:pl-12">
      {loading ? (
        <p className="text-lg font-semibold text-center">Loading coupons...</p>
      ) : coupons.length === 0 ? (
        <div className="text-center flex items-center">
          <img src={icons.couponsIcon} alt="No Coupons" className="w-48 mx-auto mb-4" />
          <p className="text-lg font-semibold flex items-center">You don’t have any coupons.</p>
        </div>
      ) : (
        <div className="relative w-full overflow-hidden z-20">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentIndex * (100 / visibleCoupons)}%)` }}
          >
            {coupons.map((coupon, index) => (
              <div
                key={index}
                className="w-full md:w-1/2 lg:w-[40%] xl:w-[35%] 2xl:w-[26%] px-2 flex-shrink-0 mt-5 z-30 cursor-pointer"
                onClick={() => openModal(coupon)}
              >
                <div className="border rounded-lg shadow-lg overflow-hidden">
                  <div className={`h-40 flex justify-center items-center relative`}>
                    <div className={`absolute inset-0 ${coupon.background || "bg-primary1"} opacity-20`}></div>
                    <img src={coupon.image} alt="Coupon" className="h-32 z-10" />
                  </div>
                  <div className="p-3 text-center">
                    <h3 className="text-xl font-bold">{coupon.discount}</h3>
                    <p className="text-sm text-gray-600">{coupon.description}</p>
                    <div className="flex justify-center items-center mt-2">
                      <span className="text-lg font-semibold">
                        Code- <span>{coupon.code}</span>
                      </span>
                      <img
                        src={icons.copyCode}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent modal from opening when copying
                          navigator.clipboard.writeText(coupon.code);
                        }}
                        className="w-5 h-5 ml-2 cursor-pointer"
                        alt="Copy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex gap-8 mt-10 relative -right-[70%]">
            <button onClick={prevSlide} className="p-2 bg-secondary rounded-full shadow-md">
              <img src={icons.arrowLeft} alt="Previous" className="w-7 h-7" />
            </button>
            <button onClick={nextSlide} className="p-2 bg-secondary rounded-full shadow-md">
              <img src={icons.arrowRight} alt="Next" className="w-7 h-7" />
            </button>
          </div>
        </div>
      )}

      {/* Full-Screen Modal */}
      {selectedCoupon && (
  <div
    className="fixed inset-0 bg-tertiary bg-opacity-50 flex justify-center items-center z-50"
    onClick={closeModal} // Close modal when clicking outside
  >
    <div
      className="bg-tertiary p-6 rounded-lg shadow-lg max-w-[50%] w-full relative"
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
    >
      <button
        onClick={closeModal}
        className="absolute top-2 right-2 text-xl font-bold text-gray-600"
      >
        &times;
      </button>
      <div className="flex flex-col md:flex-row items-center">
        {/* Image with Background Color */}
        <div
          className="p-4 rounded-lg flex justify-center items-center"
          style={{ backgroundColor: selectedCoupon.bgColor }} // Dynamically set bg color
        >
          <img
            src={selectedCoupon.image}
            alt="Coupon"
            className="w-32 h-32 md:w-40 md:h-40 lg:w-60 lg:h-60"
          />
        </div>

        {/* Coupon Details */}
        <div className="text-left ml-4">
          <h3 className="text-2xl font-semibold font-outfit">{selectedCoupon.discount}</h3>
          <p className="text-gray-600">{selectedCoupon.description}</p>
          <p className="text-lg font-normal font-outfit mt-2 text-primary1">
            Code - <span className="text-hcolor">{selectedCoupon.code}</span>
            <img
              src={icons.copyCode}
              onClick={() => navigator.clipboard.writeText(selectedCoupon.code)}
              className="w-5 h-5 ml-2 inline cursor-pointer"
              alt="Copy"
            />
          </p>
          <p className="text-base text-primary1 font-outfit font-light mt-2 mb-5">
          Enter the coupon code to receive discounts on your order.
          </p>
          <p className="text-sm text-hcolor font-poppins font-light"><span className="text-primary1 font-normal">Note:</span><br />
            <ul className="list-disc ml-2">
              <li>Coupons will have an expiry date.</li>
              <li>The coupon is for one-time use.</li>
              <li>Once used, the coupon cannot be redeemed again.</li>
            </ul>
          </p>
          <p className="text-base font-outfit font-light text-primary1 mt-5">
  By continuing, you agree to our{" "}
  <span>
    <a
      onClick={(e) => {
        e.stopPropagation(); // Prevents event bubbling
        navigate('/terms-and-conditions');
      }}
      className="text-blue-500 cursor-pointer underline"
    >
      Terms & Conditions
    </a>
  </span>.
</p>

        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
}
